<script setup>
import AuthorBox from '../components/tradingroom/AuthorBox.vue';
import { onMounted, ref } from 'vue';
import { store } from '../store.js';

const authors = ref([]);
const loading = ref(false);

onMounted(async () => {
    await fetchAuthors();
});

const fetchAuthors = async () => {
    loading.value = true;
    try {
        await store.dispatch('authors/index');
        authors.value = store.getters['authors/all'];
    } catch (error) {
        console.error('Error loading team data:', error);
    } finally {
        loading.value = false;
    }
};
</script>

<template>
    <div class="container mx-auto py-32 px-6">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <AuthorBox v-for="author in authors" preview :name="author.author" :authors="authors" />
        </div>
    </div>
</template>
